<template>
  <div>
    <h2>{{title}}</h2>
    <div class="back display-flex" @click="onCloseHistory()">
      <image-svg :imageClass="imageClass" :imageName="imageName"/>
    </div>
  </div>
</template>

<script>
import ImageSVG from '@/components/common/ImageSVG.vue'
export default {
  components: {
    'image-svg': ImageSVG
  },
  props: {
    title: String,
    imageClass: String,
    imageName: {
      type: String,
      required: true
    }
  },
  methods: {
    onCloseHistory: function () {
      this.$emit('onCloseHistory')
    }
  }
}
</script>
